import * as types from '../types';

export const DEFAULT_STATE = {
  oakID: '',
  email: '',
  registered: false,
  isLoading: false,
};

export default (state = DEFAULT_STATE, action = {}) => {
  switch (action.type) {
    case types.REGISTER_OAK_MEMBER_LOGIN_REQUEST: return {
      ...state,
      oakID: '',
      email: '',
      isLoading: true,
    };
    case types.REGISTER_OAK_MEMBER_LOGIN_SUCCESS: return {
      ...state,
      oakID: action.payload.id,
      email: action.payload.email,
      isLoading: false,
    };
    case types.REGISTER_OAK_MEMBER_LOGIN_FAILURE: return {
      ...state,
      isLoading: false,
    };
    case types.REGISTER_COMPETITION_REQUEST: return {
      ...state,
      isLoading: true,
    };
    case types.REGISTER_COMPETITION_SUCCESS: return {
      ...state,
      isLoading: false,
      registered: true,
    };
    case types.REGISTER_COMPETITION_FAILURE: return {
      ...state,
      isLoading: false,
    };
    default: return state;
  }
};
